<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-edit-button/course-edit-button.component.ts.CourseEditButtonComponent.html